export default {
  title: 'Imagine cod promoțional',
  select: {
    generate_title: 'Generează o imagine cu AI',
    generate_subtitle: 'Vom crea una pe baza codului tău promoțional principal.',
    generate_cta: 'Generează',
    upload_link: 'sau încarcă de pe dispozitivul tău',
    rate_limit_company: {
      title: 'Avem nevoie de un moment',
      description: 'Restaurantul tău a generat multe imagini în această oră. Încearcă din nou în {{time}}.',
    },
    rate_limit_promo_code: {
      title: 'O scurtă pauză',
      description:
        'Se pare că ai încercat acest cod promoțional de câteva ori la rând. Vom fi gata din nou în {{time}}.',
    },
  },
  generating: {
    title: 'Se generează imaginea…',
    progress: {
      cooking: 'Pregătim ceva delicios…',
      plating: 'Platare…',
      finishing: 'Adăugăm ultimele detalii…',
    },
  },
  preview: {
    alt: 'Imagine generată pentru codul promoțional',
    hint: 'Nu e tocmai bine? Regenerează sau continuă să decupezi imaginea.',
    click_to_expand: 'Fă clic pentru a extinde',
    regenerate: 'Regenerează',
    continue: 'Continuă editarea',
  },
  toasts: {
    upload_success: 'Imagine încărcată cu succes.',
    upload_failed: 'Încărcarea imaginii a eșuat.',
    delete_success: 'Imagine ștearsă cu succes.',
    delete_failed: 'Ștergerea imaginii a eșuat.',
    generate_success: 'Imagine generată cu succes.',
    generate_failed: 'Pornirea generării imaginii a eșuat.',
    generate_timeout: 'Imaginea este în curs de generare. Va apărea aici când va fi gata.',
    rate_limit_company: 'Limita orară de imagini pentru acest restaurant a fost atinsă. Încearcă din nou în {{time}}.',
    rate_limit_promo_code: 'Prea multe încercări pentru acest cod promoțional — încearcă din nou în {{time}}.',
  },
  time: {
    seconds_one: '1 secundă',
    seconds_few: '{{count}} secunde',
    seconds_other: '{{count}} secunde',
    minutes_one: '1 minut',
    minutes_few: '{{count}} minute',
    minutes_other: '{{count}} minute',
    hours_one: '1 oră',
    hours_few: '{{count}} ore',
    hours_other: '{{count}} ore',
  },
};
